export default {"src":"/_next/static/media/amazon_red.14517947.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};